import styled from 'styled-components';
import React, { ReactNode } from 'react';

interface ArticleCardTitleProps {
  children?: ReactNode;
  large?: boolean;
  className?: string;
}

function ArticleCardTitle({
  large,
  children,
  className,
}: ArticleCardTitleProps) {
  return (
    <ArticleCardTitleCss className={className} large={large}>
      {children}
    </ArticleCardTitleCss>
  );
}
const ArticleCardTitleCss = styled.span<{ large?: boolean }>`
  ${p => p.theme.getFontStyle('secondary', 'semiBold')}
  font-size: ${p =>
    p.large ? p.theme.typography.textBase : p.theme.typography.textSm};
  color: ${p => p.theme.articleCard.titleColor};
  line-height: 1.4;
`;

export default ArticleCardTitle;
